import { useQuery } from 'react-query';
import * as bannersAPI from '../../lib/api/banners';

const identifier = 'banners';

export const useBanner = () => useQuery([identifier], bannersAPI.fetch);
